export default "__VITE_ASSET__ae82aefa__"